import './tableConfig.css';
import { defaultAccordionPanelConfiguration } from '../../../constants/constants';
import { mergeConfigurationAccordionPanelStyles } from '../../../utils/styles';
import AccordionPanelFields from '../../common/boxStyleFields/AccordionPanelFields';
import BoxStyleList from './BoxStyleList';
import { useBoxStyleTab } from './useBoxStyleTab';
import { useShareWithConfigPreview } from '../../../contexts/ConfigPreviewContext';

/**
 * Modèles de Volet du template.
 *
 * Un modèle porte les props communes **aux noms du bloc web** (couleurs en
 * CSS) : appliqué à une box, il y est recopié tel quel, et le parser le
 * recopie ensuite dans le site sans traduction. Les deux couleurs de texte, en
 * revanche, ne valent que dans le document.
 *
 * Les champs sont exactement ceux du panel de droite d'un volet : un modèle
 * n'est qu'un point de départ.
 */
export const TabsAccordionPanel = () => {
  const {
    styleList, selectedStyle, selectedStyleId, locked, listHandlers,
    setProp, labelOfColor, colorOfLabel,
  } = useBoxStyleTab({
    configKey: 'accordionPanelStyles',
    defaultStyle: defaultAccordionPanelConfiguration,
    mergeStyles: mergeConfigurationAccordionPanelStyles,
  });
  // Style montré sur la page d'aperçu du Drawer.
  useShareWithConfigPreview('accordionPanelStyleId', selectedStyleId);

  return (
    <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
      <BoxStyleList
        title="Liste des modèles de volets"
        styles={styleList}
        selectedId={selectedStyleId}
        {...listHandlers}
      />

      <div style={{ display: 'flex', flexDirection: 'column', width: '60%', margin: 20 }}>
        <div style={{ width: '100%' }} key={selectedStyleId}>
          <AccordionPanelFields
            style={selectedStyle}
            locked={locked}
            setProp={setProp}
            labelOfColor={labelOfColor}
            colorOfLabel={colorOfLabel}
          />
        </div>
      </div>
    </div>
  );
};

export default TabsAccordionPanel;
